"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const antd_1 = require("antd");
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const PaymentStyled_1 = require("../../../../pages/paymentBooking/payment/PaymentStyled");
const RoutesPaths_1 = require("../../../../routes/RoutesPaths");
const users_1 = require("../../../../utils/users");
const ButtonPrimary_1 = __importDefault(require("../../../shared/ButtonPrimary"));
const style_1 = require("./style");
const ConfirmValuesContext_1 = require("../../../../pages/paymentBooking/context/ConfirmValuesContext");
const DisplayEmailAndLogin = ({ readOnly, form, onChange, inputValue, display = true }) => {
    const confirmValuesContext = (0, ConfirmValuesContext_1.useConfirmValues)();
    const location = (0, react_router_dom_1.useLocation)();
    const history = (0, react_router_dom_1.useHistory)();
    const handleLoginPayment = (0, react_1.useCallback)((route) => {
        const lastUrl = location.pathname + location.search;
        (0, users_1.setLastPageBeforeLogin)(lastUrl);
        history.push(route);
    }, [history, location]);
    (0, react_1.useEffect)(() => {
        var _a, _b, _c, _d;
        if ((_b = (_a = confirmValuesContext.confirmValues) === null || _a === void 0 ? void 0 : _a.suite) === null || _b === void 0 ? void 0 : _b.buildingName) {
            document.title = `360 Suítes - ${(_d = (_c = confirmValuesContext.confirmValues) === null || _c === void 0 ? void 0 : _c.suite) === null || _d === void 0 ? void 0 : _d.buildingName} - Pagamento`;
        }
    }, [confirmValuesContext.confirmValues]);
    return (react_1.default.createElement(react_1.default.Fragment, null, !(0, users_1.checkUserIsAuth)() && (react_1.default.createElement(antd_1.Form, { form: form },
        react_1.default.createElement(PaymentStyled_1.SubTitle, { style: { marginTop: '25px' }, level: 4 }, "Como prefere comprar?"),
        react_1.default.createElement(antd_1.Row, { justify: "space-between", align: "bottom" },
            react_1.default.createElement(style_1.DisplayLoginButton, { lg: {
                    span: 10,
                    order: 1,
                }, sm: {
                    span: 24,
                    order: 1,
                }, xs: {
                    span: 24,
                    order: 1,
                }, display: display },
                react_1.default.createElement(ButtonPrimary_1.default, { htmlType: "submit", onClick: () => handleLoginPayment(RoutesPaths_1.routesPaths.login), style: { minWidth: 264 } }, "J\u00E1 tenho conta")),
            react_1.default.createElement(antd_1.Col, { xs: {
                    span: 24,
                    order: 2,
                }, sm: {
                    span: 24,
                    order: 2,
                }, lg: {
                    span: 2,
                    order: 2,
                } },
                react_1.default.createElement(style_1.DiagonalDivider, { display: display },
                    react_1.default.createElement("div", { className: "diagonal-divider-line" }),
                    react_1.default.createElement("span", null, "ou"),
                    react_1.default.createElement("div", { className: "diagonal-divider-line" }))),
            react_1.default.createElement(antd_1.Col, { lg: {
                    span: 10,
                    order: 3,
                }, sm: {
                    span: 24,
                    order: 3,
                }, xs: {
                    span: 24,
                    order: 3,
                } },
                react_1.default.createElement(ButtonPrimary_1.default, { htmlType: "submit", onClick: () => handleLoginPayment(RoutesPaths_1.routesPaths.register), style: { minWidth: 264 } }, "Fazer cadastro")))))));
};
exports.default = DisplayEmailAndLogin;
